<template>
  <div class="wrap">
    <div class="row">
      <div v-html="content.html2"></div>
    </div>
    <table class="row">
      <tr>
        <td>
          <h1 class="row">
            {{translate('shipping-proforma-invoice')}} {{translate('number-symbol')}}: {{salesOrder.shippingPorformaNumber}}
          </h1>
        </td>
        <td>
          <span class="title">{{translate('date')}}:</span>
          <span>{{salesOrder.paymentChequeNo | toDate}}</span>
        </td>
      </tr>
    </table>
    <company-box
      :title="translate('ship-to')"
      :translate="translate"
      :company="salesOrder.supplierCompany"
      :company-detail="salesOrder.supplierCompanyDetail"
      :company-contact="rfq2sFirst.supplierContact"
      style="width: 80%"
     />
    <table class="row box-content">
      <tr class="table__row">
        <th><div class="title">{{translate('order')}} {{translate('number-symbol')}}:</div></th>
        <th><div class="title uppercase">{{translate('awb')}}:</div></th>
        <th><div class="title">{{translate('ship-via')}}:</div></th>
        <th><div class="title">{{translate('account')}} {{translate('number-symbol')}}:</div></th>
        <th><div class="title">{{translate('country-origin')}}:</div></th>
        <th><div class="title">{{translate('number-symbol')}} {{translate('boxes')}}:</div></th>
      </tr>
      <tr class="table__row">
        <td align="center"><div>{{salesOrder.baxpo}}</div></td>
        <td align="center"><div>{{salesOrder.awb}}</div></td>
        <td align="center"><div>{{salesOrder.shipViaForwarder.shipper.shipperName}}</div></td>
        <td align="center"><div>{{salesOrder.shipViaForwarder.accountNumber}}</div></td>
        <td align="center"><div>{{salesOrder.countryOrigin.title}}</div></td>
        <td align="center"><div class="uppercase">{{salesOrder.noOfBoxes}}</div></td>
      </tr>
    </table>
    <table-list
      :columns="[
        { label: translate('qty'), renderColumn: (row) => row.qty },
        { label: translate('part-number'), renderColumn: (row) => row.part.partNumber },
        { label: translate('s/n'), renderColumn: (row) => row.partSN },
        { label: translate('description'), renderColumn: (row) => row.part.partDescription },
        { label: translate('condition'), renderColumn: (row) => row.condition.title },
        { label: translate('u/price'), renderColumn: (row) => $options.filters.toPrice(row.price) },
        { label: translate('total'), renderColumn: (row) => $options.filters.toPrice(row.price * row.qty) }
      ]"
      :data="rfq2s"
    >
    </table-list>
    <table class="row">
      <tr>
        <td style="width: 70%" valign="top">
          <div>
            <h3>{{translate('notes')}}:</h3>
            <p v-html="salesOrder.remarks"></p>
          </div>
        </td>
        <td>
          <table class="table-sum">
            <tr class="table__row">
              <td><div class="capitalize">{{translate('sub-total')}}:</div></td>
              <td><div>{{subTotal | toPrice}}</div></td>
            </tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('vat')}}% {{salesOrder.vat.vatValue | toPrice}}:</div></td>
              <td><div>{{vatSum | toPrice}}</div></td>
            </tr>
            <tr class="box-content table__row">
              <td><div class="capitalize">{{translate('total')}}:</div></td>
              <td><strong>{{total | toPrice}}</strong></td>
            </tr>
            <tr class="table__row">
              <td><div class="capitalize">{{translate('currency')}}:</div></td>
              <td><div>{{rfq2sFirst.currency.title}}</div></td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <div class="row">
      <div v-html="content.html1"></div>
    </div>
    <table>
      <tr>
        <td colspan="3">
          <h3>{{translate('contact')}}:</h3>
        </td>
      </tr>
      <tr>
        <td>
          <span class="title">{{salesOrder.employee.name}}</span>
        </td>
        <td>
          <span class="title">{{translate('phone')}}:</span>
          <span>{{salesOrder.employee.contact.phone}}</span>
        </td>
        <td>
          <span class="title">{{translate('e-mail')}}:</span>
          <span>{{salesOrder.employee.contact.email}}</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { toDate, toPrice } from '@/utils/filters'
import TableList from './components/table-list'
import CompanyBox from './components/company-box'

export default {
  name: 'PdfProformaShipSupplier',
  components: {
    'table-list': TableList,
    'company-box': CompanyBox
  },
  props: {
    translate: {
      type: Function
    },
    salesOrder: {
      type: Object
    },
    rfq2s: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    rfq2sFirst () {
      return this.rfq2s[0] || { currency: {}, supplierContact: {} }
    },
    vatSum () {
      const vatPercent = (this.salesOrder.vat.vatValue || 0) / 100
      return this.subTotal * vatPercent
    },
    subTotal () {
      return this.rfq2s.reduce((result, detail) => result + (detail.qty * detail.price), 0)
    },
    total () {
      return this.subTotal + this.vatSum
    }
  },
  filters: {
    toPrice: toPrice,
    toDate: toDate
  }
}
</script>
